import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isStringResolver } from '@pct-ts/typeguard';
import type { StringResolver } from '@pct-ts/typing';

@Pipe({
  name: 'isStringResolver',
})
export class IsStringResolverPipe implements PipeTransform {
  transform<T>(value: unknown): value is StringResolver<T> {
    return isStringResolver<T>(value);
  }
}
